import apolloCacheInMemory, {
  ApolloClient,
  FetchPolicy,
  ErrorPolicy,
  ApolloClientOptions,
  InMemoryCache
} from '@apollo/client'
import { PossibleTypesResultData } from '../graphql/gqlPrivateSchemaFragments'
import { isSSR } from '../../../shared/helpers'

export type ApolloClientType =
  ApolloClient<apolloCacheInMemory.NormalizedCacheObject>

export const makeApolloClient = (
  opts: Partial<ApolloClientOptions<any>>,
  generatedPossibleTypes?: PossibleTypesResultData
): ApolloClientType => {
  const mergePolicy:
    | apolloCacheInMemory.FieldPolicy<any, any, any>
    | apolloCacheInMemory.FieldReadFunction<any, any> = {
    merge(existing, incoming) {
      return { ...existing, ...incoming }
    }
  }
  return new ApolloClient({
    cache: new InMemoryCache({
      addTypename: true,
      possibleTypes: generatedPossibleTypes?.possibleTypes,
      typePolicies: {
        OrganisationModelAsAdmin: {
          fields: {
            features: mergePolicy
          }
        },
        OrganisationModelGQLBase: {
          fields: {
            features: mergePolicy
          }
        },
        UserModelSelfMutation: {
          fields: {
            patch: mergePolicy
          }
        },
        Query: {
          fields: {
            admin: mergePolicy
          }
        },
        Mutation: {
          fields: {
            admin: mergePolicy,
            me: mergePolicy
          }
        }
      }
    }),
    defaultOptions: {
      watchQuery: {
        fetchPolicy: 'cache-and-network' as FetchPolicy,
        errorPolicy: 'all' as ErrorPolicy // DO NOT SET TO "ignore" UNDER ANY CIRCUMSTANCE, see https://github.com/apollographql/apollo-client/issues/5551
      },
      query: {
        errorPolicy: 'all' as ErrorPolicy
      }
    },
    queryDeduplication: true,
    connectToDevTools: !isSSR,
    ...opts
  })
}
